'use client'

import React from 'react'

import { createGenericContext } from './generic-context'

interface IShipmentContext {
  isShipmentOwner: boolean
  shipmentID: string
  shipmentNumber: string
}

// Context that throws when used outside provider
const [useShipmentContext, ShipmentContextProvider] = createGenericContext<IShipmentContext>(
  'useShipmentContext must be used within a ShipmentProvider'
)

interface ShipmentProviderProps {
  children: React.ReactNode
  isShipmentOwner: boolean
  shipmentID: string
  shipmentNumber: string
}

/**
 * Provider component for shipment context
 */
const ShipmentProvider = ({ children, isShipmentOwner, shipmentID, shipmentNumber }: ShipmentProviderProps) => {
  const value = { isShipmentOwner, shipmentID, shipmentNumber }
  return <ShipmentContextProvider value={value}>{children}</ShipmentContextProvider>
}

export { ShipmentProvider, useShipmentContext }
